import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const SectionStyled = styled.div`
  border-bottom: 0.1rem solid ${colors.neutral[300]};
  padding-bottom: 1rem;

  &:last-child {
    border-bottom: none;
  }
`;

export const SectionHeaderStyled = styled.div`
  padding: 2rem 2rem 1rem;
  margin: 0;
  display: flex;
  align-items: center;
`;

export const TypeNameStyled = styled.span`
  ${typography.regular[18]};
  margin-left: 0.8rem;
  text-transform: capitalize;
`;

export const ItemsWrapperStyled = styled.ul`
  padding: 0 3.5rem;
  list-style: none;
  margin: 0;
`;

export const ItemStyled = styled.li`
  padding: 1.2rem 0;
`;

export const EmptyMessageStyled = styled.li`
  ${typography.regular[16]};
  color: ${colors.neutral[600]};
  padding: 0.5rem 0 1.5rem 1.8rem;
`;
